module.exports = __webpack_public_path__ + "img/ggx.cc098b57.png";